<template lang="pug">
  BasePopup.b-user-detail-popup(v-if="isOpened" @close="isOpened = false;")
    ._container
      UserAvatar._avatar(:user="avatar" :size="80")
      ._name {{ user.name }} {{ user.surname }}
      ._label Дата регистрации
      ._value {{ createdAt }}
      ._label Способы связи
      ._value.-social
        template(v-for="service in socialServices")
          a._social-item(v-if="user[service.name]" :href="service.href(user[service.name])" @click="service.handler" target="_blank")
            Icon._social-icon(:name="service.icon" pointer)
      ._footer(v-if="$slots.default")
        slot
</template>

<script>
import utils from '@/utils/common';

import UserAvatar from '@/components/UserAvatar.vue';
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'UserDetailPopup',
  components: { BasePopup, UserAvatar },
  controller: null,
  props: {
    user: Object,
  },
  data() {
    return {
      isOpened: false,
    };
  },
  computed: {
    createdAt() { return utils.convertDateToString(new Date(this.user.createdAt)); },
    image() { return this.user?.avatar?.thumbnails?.preview; },
    avatar() { return this.image ? { id: this.user.id, avatar: { url: this.image } } : { id: this.user.id }; },
    socialServices() {
      return [
        { name: 'email',    icon: 'mail',     href: (val) => `mailto:${val}`,         handler: this.emailClick  }, // eslint-disable-line
        { name: 'phone',    icon: 'phone',    href: (val) => `tel:${val}`,            handler: this.phoneClick  }, // eslint-disable-line
        { name: 'skype',    icon: 'skype',    href: (val) => `skype:${val}`,          handler: () => {}         }, // eslint-disable-line
        { name: 'telegram', icon: 'telegram', href: (val) => `https://t.me/${val}`,   handler: () => {}         }, // eslint-disable-line
        { name: 'whatsapp', icon: 'whatsapp', href: (val) => `https://wa.me/${val}`,  handler: () => {}         }, // eslint-disable-line
      ];
    },
  },
  methods: {
    open() {
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.isOpened = false;
      this.$options.controller.resolve();
    },
    emailClick(e) {
      e.preventDefault();
      navigator.clipboard.writeText(this.user.email);
      this.$push({ text: 'E-mail скопирован в буфер обмена' });
    },
    phoneClick(e) {
      const isPhone = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      if (!isPhone) {
        e.preventDefault();
        navigator.clipboard.writeText(this.user.phone);
        this.$push({ text: 'Телефон скопирован в буфер обмена' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user-detail-popup {
  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    min-width: 370px;
  }

  &__avatar {
    justify-self: center;
    grid-column: 2 span;
  }

  &__name {
    justify-self: center;
    grid-column: 2 span;

    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
    margin-bottom: 10px;
  }

  &__social-icon {
    fill: #99A3C5;
  }

  &__label {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;

    color: #1E3147;
  }

  &__value {
    justify-self: right;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #33A1FB;

    &--social {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  &__footer {
    margin-top: 25px;
    grid-column: 2 span;
  }
}
</style>
